'use strict';

const _ = require('underscore');
const Backbone = require('backbone');

const NavItemModel = Backbone.Model.extend({
    defaults: {
        active: false
    },

    getHeader: function() {
        return this.get('header');
    },

    isActive: function() {
        return this.get('active');
    },

    _setActive: function(active) {
        this.set({active: active});
    },

    activate: function() {
        if(this.isActive()) {
            return;
        }
        this._setActive(true);
        this.trigger('active', this);
    },

    deactivate: function() {
        if(!this.isActive()) {
            return;
        }
        this._setActive(false);
        this.trigger('inactive', this);
    },

    toggle: function() {
        if(!this.isActive()) {
            this.activate();
        }
    }
});

module.exports = Backbone.Collection.extend({
    model: NavItemModel,
    initialize: function() {
        this.on('active', model => {
            const actives = this.getActiveModels();

            // さっきまで active だった nav と異なる nav が toggle されたケース
            if(actives.length > 1) {
                _.each(actives, a => {
                    if(a != model) {
                        a.deactivate();
                    }
                });
            }

            if(actives.length == 1) {
                this.trigger('active:all');
            }
        });

        this.on('inactive', () => {
            const actives = this.getActiveModels();

            // 全部 inactive になったケース
            if(actives.length == 0) {
                this.trigger('inactive:all');
            }
        });
    },

    getActiveModels: function() {
        return this.filter(model => model.isActive());
    }
});




// WEBPACK FOOTER //
// ./common/ui/view/toggle-nav/collection.js